import { useState, useCallback } from 'react';

/**
 * Hook personalizado para manejar el modal de alerta temporal
 * 
 * @returns {Object} Objeto con:
 * - showAlert: función para mostrar el alert
 * - showAlertModal: estado booleano que controla si se muestra el modal
 * - alertMessage: mensaje actual del alert
 * - alertType: tipo de alert ('success' o 'error')
 * - setShowAlertModal: función para controlar manualmente el estado
 */
const useAlertModal = () => {
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('success');

    const showAlert = useCallback((message, type = 'success', autoCloseDelay = 3000) => {
        setAlertMessage(message);
        setAlertType(type);
        setShowAlertModal(true);
        
        if (autoCloseDelay > 0) {
            setTimeout(() => {
                setShowAlertModal(false);
            }, autoCloseDelay);
        }
    }, []);

    const hideAlert = useCallback(() => {
        setShowAlertModal(false);
    }, []);

    // Función helper para extraer mensaje de error del resultado
    const getErrorMessage = useCallback((result) => {
        if (result?.data?.message) {
            return result.data.message;
        }
        if (result?.data?.error) {
            return result.data.error;
        }
        if (result?.message) {
            return result.message;
        }
        if (typeof result?.data === 'string') {
            return result.data;
        }
        return 'Ha ocurrido un error. Por favor, intente nuevamente.';
    }, []);

    return {
        showAlert,
        hideAlert,
        showAlertModal,
        alertMessage,
        alertType,
        setShowAlertModal,
        getErrorMessage
    };
};

export default useAlertModal;
